// @flow
import React from "react";
import styled, { css } from "styled-components";

const InfoSvg = styled.svg`
  display: inline-block;
  margin-right: 7px;
  width: 16px;
  min-width: 16px;
  height: 16px;
  fill: ${({ fillColor }) => fillColor || "rgb(165, 164, 164)"};

  ${props =>
    props.verification &&
    props.theme.direction === "rtl" &&
    css`
      margin-right: 0;
      margin-left: 7px;
    `};
`;

const ErrorSvg = styled.svg`
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
  width: 18px;
  height: 17px;
  margin-right: 10px;
  fill: ${props => props.theme.lower};
`;

const BackSvg = styled.svg`
  display: inline-block;
  width: 19px;
  height: 16px;
  margin-right: 7px;
  fill: #a5a4a4;
  fill-rule: evenodd;
`;

export const InfoIcon = (props: {}) => (
  <InfoSvg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fillColor={props.fill}
    {...props}
  >
    <path d="M8.006,0.011 C3.590,0.011 0.010,3.591 0.010,8.007 C0.010,12.423 3.590,16.002 8.006,16.002 C12.422,16.002 16.001,12.423 16.001,8.007 C16.001,3.591 12.422,0.011 8.006,0.011 ZM7.007,3.990 L9.014,3.990 L9.014,5.965 L7.007,5.965 L7.007,3.990 ZM9.986,11.959 L6.004,11.959 L6.004,10.956 L7.007,10.956 L7.007,8.006 L6.004,8.006 L6.004,7.003 L9.014,7.003 L9.014,10.956 L9.986,10.956 L9.986,11.959 Z" />
  </InfoSvg>
);

export const ErrorIcon = (props: {}) => (
  <ErrorSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17" {...props}>
    <path d="M17.465,12.999 L11.262,2.256 C10.249,0.481 7.686,0.481 6.677,2.256 L0.470,12.999 C-0.543,14.774 0.718,16.978 2.763,16.978 L15.151,16.978 C17.195,16.978 18.478,14.752 17.465,12.999 ZM8.966,14.595 C8.426,14.595 7.978,14.147 7.978,13.608 C7.978,13.068 8.426,12.620 8.966,12.620 C9.505,12.620 9.953,13.068 9.932,13.633 C9.957,14.147 9.483,14.595 8.966,14.595 ZM9.866,8.210 C9.822,8.976 9.775,9.737 9.731,10.503 C9.709,10.750 9.709,10.976 9.709,11.221 C9.687,11.625 9.370,11.938 8.966,11.938 C8.561,11.938 8.248,11.647 8.222,11.242 C8.157,10.051 8.087,8.881 8.022,7.689 C8.000,7.376 7.978,7.059 7.953,6.746 C7.953,6.228 8.244,5.802 8.718,5.667 C9.192,5.554 9.662,5.780 9.866,6.228 C9.935,6.385 9.957,6.541 9.957,6.724 C9.935,7.223 9.888,7.719 9.866,8.210 Z" />
  </ErrorSvg>
);

export const BackIcon = (props: {}) => (
  <BackSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 16">
    <path d="M8.043,0.485 L1.241,7.287 C0.845,7.683 0.845,8.326 1.241,8.722 L8.043,15.524 C8.439,15.920 9.082,15.920 9.478,15.524 C9.874,15.127 9.874,14.485 9.478,14.088 L4.386,8.997 L17.972,8.997 C18.532,8.997 18.987,8.543 18.987,7.982 C18.987,7.422 18.532,6.968 17.972,6.968 L4.431,6.968 L9.478,1.920 C9.874,1.524 9.874,0.882 9.478,0.485 C9.082,0.089 8.439,0.089 8.043,0.485 Z" />
  </BackSvg>
);



// WEBPACK FOOTER //
// ./src/components/ReVerification/Icons.js